<mat-select
  #select
  (keydown.space)="$event.stopPropagation()"
  (selectionChange)="onSelectionChange($event.value)"
  (openedChange)="onOpenedChange($event)"
  [value]="value()"
  [disabled]="disabled()"
  [compareWith]="compareFn"
  [errorStateMatcher]="errorStateMatcher"
  class="w-full text-proffeo-text items-center justify-center rounded-md border bg-proffeo-surface border-proffeo-overlay-subtle px-3 py-2"
>
  <mat-select-trigger>
    <div class="flex items-center text-nowrap text-proffeo-text gap-1.5">
      {{ value()?.value }}
    </div>
  </mat-select-trigger>
  @for (item of optionItems(); track $index) {
    <mat-option
      (keydown.space)="$event.stopPropagation()"
      [value]="item"
      class="w-full"
    >
      <div class="flex w-full items-center truncate text-nowrap gap-1.5">
        {{ item.value }}
      </div>
    </mat-option>
  }
  <mat-option
    (click)="$event.stopPropagation()"
    (keydown.space)="$event.stopPropagation()"
    aria-disabled="true"
    class="w-full"
  >
    <mat-checkbox
      (change)="onNewDictionaryItemCheckboxChange($event)"
      (click)="$event.stopPropagation()"
      [checked]="isNewDictionaryItem()"
    >
      {{ label() }}
    </mat-checkbox>
    @if (isNewDictionaryItem()) {
      <proffeo-ui-input
        (valueChange)="onNewOptionChange($event)"
        (mousedown)="$event.stopPropagation()"
        (click)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()"
        (keydown.enter)="addOption()"
        [value]="newOption()"
        variant="inline"
      />
      <div class="flex justify-end mt-1 mb-2">
        <button
          (click)="cancelNewOption(); $event.stopPropagation()"
          class="button-secondary"
        >
          {{ 'osh.osh-analysis-cancel' | translate }}
        </button>
        <button
          (mousedown)="$event.stopPropagation()"
          (click)="$event.stopPropagation(); addOption()"
          [disabled]="!newOption().trim()"
          class="ml-2 button"
        >
          {{ 'osh.osh-analysis-save' | translate }}
        </button>
      </div>
    }
  </mat-option>
</mat-select>
@if (showError() && errorText()) {
  <mat-error class="text-sm">{{ errorText() | translate }}</mat-error>
}
